import { useAppSelector } from '@/store/hooks';
import { selectWorkingProjectDefaultLanguage, selectWorkingProjectUuid } from '@/store/slices/project/selectors';
import { PATHNAMES } from '@/utils/pathnames';
import useLanguageParams from '@/utils/use-language-params';
import { useProjectUuidParam } from '@/utils/use-project-uuid-param';
import Container from '@ui/container/container';
import Link from '@ui/links/link';
import Text from '@ui/text/text/text';
import { generatePath } from 'react-router-dom';

const ViewAudienceListsLink = ({ show }: { show: boolean }) => {
  const projectUuidParams = useProjectUuidParam();
  const languageParms = useLanguageParams();

  const workingProjectUuid = useAppSelector(selectWorkingProjectUuid);
  const projectDefaultLanguage = useAppSelector(selectWorkingProjectDefaultLanguage);

  const projectUuid = projectUuidParams || workingProjectUuid;
  const language = languageParms || projectDefaultLanguage;

  if (!projectUuid || !language) return null;
  return (
    <Container opacity={show ? 1 : 0} inert={show ? false : true} className="inline-flex">
      <Text className="C2" design="GlobalIcoText3">
        <Link
          design="standard_link"
          to={generatePath(PATHNAMES.Edit.AudienceLists, { projectUuid, language })}
          className="inline-flex"
        >
          View Audience Lists
        </Link>
      </Text>
    </Container>
  );
};

export default ViewAudienceListsLink;
